import React from 'react';
import PropTypes from 'prop-types';
import {CardForm} from './';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getCustomer, hideDeleteCard, deleteCard} from 'actions';

class DeleteCard extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'DeleteCard';

        this.cancel = this.cancel.bind(this);
        this.deleteCard = this.deleteCard.bind(this);
    }
    cancel() {
    	this.props.dispatch(hideDeleteCard());
    }
    deleteCard() {
    	if(this.props.account.card) {
    		this.props.dispatch(deleteCard(this.props.account.card, (error, confirmation)=>{
    			if(error) {
    				displayNotice(error, {type : "error", style : "danger", position: "stack-bar-top"});
    			}
    			else {
    				displayNotice({message : "Card has been deleted."}, {type : "success", style : "success", position: "stack-bar-top"});
    				this.props.dispatch(getCustomer((error, customer) => {
    					if(error) {
		    				displayNotice(error, {type : "error", style : "danger", position: "stack-bar-top"});
    					}
    				}));
					this.props.dispatch(hideDeleteCard());
    			}
    		}));
    	}
    }
    render() {
    	var {cancel, deleteCard} = this;
    	if(this.props.account.card && this.props.account.customer && this.props.account.customer.sources.data.length > 1)
	        return (
	        	<div>
	        		<Modal show={this.props.account.deletingCard} onHide={cancel}>
	        			<div className="panel panel-danger mb-none">
	        				<div className="panel-heading">
	        					<h3 className="panel-title">Delete Card - {this.props.account.card.last4}</h3>
	        				</div>
	        				<div className="panel-body">
	        				<p>Are you sure you want to delete your card ending in {this.props.account.card.last4}?</p>
	        				</div>
	        				<div className="panel-footer">
	        					<div className="row">
	        						<div className='col-xs-12 col-md-4 col-md-offset-4'>
	        							<div onClick={cancel} className="btn btn-block btn-default">Cancel</div>
	        						</div>
	        						<div className='col-xs-12 col-md-4'>
	        							<div onClick={deleteCard} className="btn btn-block btn-danger"><i className="fa fa-trash"></i> Yes, Remove it. </div>
	        						</div>
	        					</div>
	        				</div>
	        			</div>
	        		</Modal>
	        	</div>
	        );
	    else if(this.props.account.card && this.props.account.customer && this.props.account.customer.sources.data.length == 1) {
	        return	<div>
	        		<Modal show={this.props.account.deletingCard} onHide={cancel}>
	        			<div className="panel panel-warning mb-none">
	        				<div className="panel-heading">
	        					<h3 className="panel-title">Delete Card - {this.props.account.card.last4}</h3>
	        				</div>
	        				<div className="panel-body">
	        				<h3>Sorry!</h3>
	        				<p>You cannot delete this card without first adding another payment option.</p>
	        				</div>
	        				<div className="panel-footer">
	        					<div className="row">
	        						<div className='col-xs-12 col-md-4 col-md-offset-8'>
	        							<div onClick={cancel} className="btn btn-block btn-success"> Ok, I Understand. </div>
	        						</div>
	        					</div>
	        				</div>
	        			</div>
	        		</Modal>
	        	</div>
	 	    }
	    else
	    	return <div></div>
    }
}

var mapStateToProps = ({account})=>{
	return {
		account
	}
}

export default connect(mapStateToProps)(DeleteCard);



// WEBPACK FOOTER //
// ./src/browser/components/account/deleteCard.js